module.exports = __webpack_public_path__ + "static/media/bilista_horizontal.ead1afff.svg";